import React from 'react';
import Loader from '../../components/Loader';
import NoData from '../../components/NoData';
import { dateFn } from '../../utils/dateTimeFormatter';
import { amountCheckFn } from '../../utils/commonUtil';

export default function AssociatedOrders({ invoice, invoiceLoading }) {
  return (
    <div className='mt-4 rounded-lg bg-white sm:mt-6 '>
      {invoiceLoading ? (
        <Loader text='loading associated orders...' classes='h-96' />
      ) : invoice?.orders?.length == 0 ? (
        <NoData text='No associated orders found' classes='h-96' />
      ) : (
        <React.Fragment>
          <header className='flex items-center border-b border-gray-100 p-4 pl-5 align-top'>
            <h5 className='go-textblackmedium-18 my-1 flex-1'>Associated Orders</h5>
          </header>
          {/* Desktop Table View */}
          <div className='hidden w-full overflow-x-auto sm:block'>
            <table className='w-full divide-y divide-slate-200'>
              <thead className='border-b border-slate-200'>
                <tr>
                  <th className='go-textblack-14 px-4 py-3 text-left sm:px-8'>Number</th>
                  <th className='go-textblack-14 px-4 py-3 text-center sm:px-8'>Delivery Date</th>
                  <th className='go-textblack-14 px-4 py-3 text-center sm:px-8'>Service Address</th>
                  <th className='go-textblack-14 px-4 py-3 text-right sm:px-8'>Amount</th>
                </tr>
              </thead>
              <tbody>
                {invoice?.orders?.map((order, idx) => (
                  <tr key={idx}>
                    <td className='go-textblacknormal-14 px-4 py-3 sm:px-8'>{order?.id}</td>
                    <td className='go-textblacknormal-14 px-4 py-3 text-center sm:px-8'>
                      {dateFn('MM/DD/YYYY', order?.dropoff_date)}
                    </td>
                    <td className='go-textblacknormal-14 px-4 py-3 text-center sm:px-8'>
                      {order?.customer_address?.full_address}
                    </td>
                    <td className='go-textblacknormal-14 px-4 py-3 text-right sm:px-8'>
                      {amountCheckFn(order?.final_total)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Mobile Card View */}
          <div className='divide-y divide-slate-100 sm:hidden'>
            {invoice?.orders?.map((order, idx) => (
              <div key={idx} className='p-4'>
                <div className='flex items-center justify-between'>
                  <span className='go-textblack-14'>#{order?.id}</span>
                  <span className='go-textblack-14'>{amountCheckFn(order?.final_total)}</span>
                </div>
                <div className='mt-1'>
                  <span className='go-textblacknormal-14 text-slate-500'>
                    {dateFn('MM/DD/YYYY', order?.dropoff_date)}
                  </span>
                </div>
                <div className='mt-1'>
                  <span className='go-textblacknormal-14 text-slate-500'>{order?.customer_address?.full_address}</span>
                </div>
              </div>
            ))}
          </div>
        </React.Fragment>
      )}
    </div>
  );
}
